import {
  Alert,
  AlertProps,
  AlertTitle,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Valve } from '../types'

export interface ValveRuuviTagInstallationInsturctionsAlertProps
  extends Omit<AlertProps, 'children'> {
  valve: Valve
}

export default function ValveRuuviTagInstallationInstructionsAlert({
  valve: _,
  ...props
}: ValveRuuviTagInstallationInsturctionsAlertProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('valve')

  return (
    <Alert severity="info" {...props}>
      <AlertTitle sx={{ m: 0 }}>{t('ValveRuuviTagInstallationInstructionsAlert.title')}</AlertTitle>

      <List>
        <ListItem sx={{ py: 0 }}>
          <ListItemAvatar sx={{ minWidth: 16 }}>1.</ListItemAvatar>
          <ListItemText primary={t('ValveRuuviTagInstallationInstructionsAlert.stepOne')} />
        </ListItem>

        <ListItem sx={{ py: 0 }}>
          <ListItemAvatar sx={{ minWidth: 16 }}>2.</ListItemAvatar>
          <ListItemText primary={t('ValveRuuviTagInstallationInstructionsAlert.stepTwo')} />
        </ListItem>

        <ListItem sx={{ py: 0 }}>
          <ListItemAvatar sx={{ minWidth: 16 }}>3.</ListItemAvatar>
          <ListItemText primary={t('ValveRuuviTagInstallationInstructionsAlert.stepThree')} />
        </ListItem>
      </List>
    </Alert>
  )
}
